import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useContext, useMemo } from 'react';
import { SectionName } from '~/constants/vdp/section';
import { usePriceDrop } from '~/hooks/vdp';
import useKBBPromo from '~/hooks/vdp/selectors/useKBBPromo';

export default function useHeroViewedEvent() {
  const { trackEvent } = useContext(AnalyticsContext);
  const { showKBBPromo } = useKBBPromo();
  const { showPriceDrop } = usePriceDrop();

  const priceBadgeList = useMemo(() => {
    const badges: string[] = [];
    if (showPriceDrop) {
      badges.push('Price Drop');
    }
    if (showKBBPromo) {
      badges.push('Great Deal');
    }

    return badges;
  }, [showKBBPromo, showPriceDrop]);

  useEffectOnce(() => {
    trackEvent(SectionName.Hero, {
      action: 'viewed',
      priceBadges: priceBadgeList
    });
  }, [priceBadgeList, trackEvent]);
}
